export default "__VITE_ASSET__B4N1p4tL__"